module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image23.06b64c03.jpg";